import m1 from '../../assets/Male-models/male1.jpeg'
import m2 from '../../assets/Male-models/m17.webp'
import m3 from '../../assets/Male-models/m4.jpeg'
import m4 from '../../assets/Male-models/m9.webp'
import m5 from '../../assets/Male-models/m5.jpeg'
import m6 from '../../assets/Male-models/m6.webp'
import m7 from '../../assets/Male-models/m7.webp'
import m8 from '../../assets/Male-models/m8.webp'
import m9 from '../../assets/Male-models/m9.webp'
import m10 from '../../assets/Male-models/m10.webp'
import m11 from '../../assets/Male-models/m11.webp'
import m12 from '../../assets/Male-models/m12.webp'
import m13 from '../../assets/Male-models/m13.webp'
import m14 from '../../assets/Male-models/m15.webp'
import m15 from '../../assets/Male-models/m16.webp'
import m16 from '../../assets/Male-models/m18.webp'
import f1 from '../../assets/Female-models/f1.jpg'
import f2 from '../../assets/Female-models/f2.jpg'
import f3 from '../../assets/Female-models/f3.jpg'
import f4 from '../../assets/Female-models/f4.jpeg'
import f5 from '../../assets/Female-models/f5.jpg'
import f6 from '../../assets/Female-models/f6.jpg'
import f7 from '../../assets/Female-models/f7.jpeg'
import f8 from '../../assets/Female-models/f8.jpeg'
import f9 from '../../assets/Female-models/f9.webp'
import f10 from '../../assets/Female-models/f10.jpeg'
import f11 from '../../assets/Female-models/f11.jpg'


const products = [
  {
    id : 1,
    img: m1,
    category: 'male',
    price: 50.00
  },
  {
    id : 2,
    img: m2,
    category: 'male',
    price: 80.00
  },
  {
    id : 3,
    img: f1,
    category: 'female',
    price: 40.00
  },
  {
    id : 4,
    img: f2,
    category: 'female',
    price: 50.00
  },
  {
    id : 5,
    img: m3,
    category: 'male',
    price: 70.00
  },
  {
    id : 6,
    img: m4,
    category: 'male',
    price: 20.00
  },
  {
    id : 7,
    img: f3,
    category: 'female',
    price: 50.00
  },
  {
    id : 8,
    img: f4,
    category: 'female',
    price: 100.00
  },
  {
    id : 9,
    img: m5,
    category: 'male',
    price: 80.00
  },
  {
    id : 10,
    img: f5,
    category: 'female',
    price: 80.00
  },
  {
    id : 11,
    img: m6,
    category: 'male',
    price: 50.00
  },
  {
    id : 12,
    img: f6,
    category: 'female',
    price: 20.00
  },
  {
    id : 13,
    img: m7,
    category: 'male',
    price: 90.00
  },
  {
    id : 14,
    img: f7,
    category: 'female',
    price: 80.00
  },
  {
    id : 15,
    img: m8,
    category: 'male',
    price: 100.00
  },
  {
    id : 16,
    img: f8,
    category: 'female',
    price: 100.00
  },
  {
    id : 17,
    img: m9,
    category: 'male',
    price: 50.00
  },
  {
    id : 18,
    img: f9,
    category: 'female',
    price: 20.00
  },
  {
    id : 19,
    img: m10,
    category: 'male',
    price: 70.00
  },
  {
    id : 20,
    img: f10,
    category: 'female',
    price: 50.00
  },
  {
    id : 21,
    img: m11,
    category: 'male',
    price: 100.00
  },
  {
    id : 22,
    img: f11,
    category: 'female',
    price: 80.00
  },
  {
    id : 23,
    img: m12,
    category: 'male',
    price: 50.00
  },
  {
    id : 24,
    img: m13,
    category: 'male',
    price: 80.00
  },
  {
    id : 25,
    img: m14,
    category: 'male',
    price: 100.00
  },
  {
    id : 26,
    img: m15,
    category: 'male',
    price: 80.00
  },
  {
    id : 27,
    img: m16,
    category: 'male',
    price: 80.00
  },
]

export default products;